import { simplePath } from "../utils.js";
const GET_USER_APPLICATION_LIST_PATH = '/v2/user/:userEmail/application-list';
function get_user_application_list_path(params) {
    return simplePath(GET_USER_APPLICATION_LIST_PATH, params);
}
export { GET_USER_APPLICATION_LIST_PATH, get_user_application_list_path };
